import { Button, ButtonType } from '@resurs-internal/styx-react'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '../common/utils'
import {
  DocViewerModal,
  docOpensInViewer,
  useDocViewer,
} from './DocViewerModal'
import styles from './Mock.module.scss'
import { useIsInternal } from './useIsInternal'
import { UseRealServiceButton } from './UseRealServiceButton'

const proxyPath = process.env.REACT_APP_RETAIL_FINANCE_MOCK_PROXY_PATH

export const CheckpointMockSigning = () => {
  const { token } = useParams()
  const { signerIndex } = useQuery()
  const [session, setSession] = useState(null)
  const [docs, setDocs] = useState([])
  const { previewDoc, openDoc, closeDoc } = useDocViewer()
  const isInternal = useIsInternal()

  useEffect(() => {
    fetch(`${proxyPath}/checkpoint-romeo-signing/${token}/status`, {
      headers: { Accept: 'application/json' },
    })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (data) setSession(data)
      })
      .catch(console.error)

    fetch(`${proxyPath}/checkpoint-romeo-signing/${token}/documents`, {
      headers: { Accept: 'application/json' },
    })
      .then(r => (r.ok ? r.json() : []))
      .then(setDocs)
      .catch(console.error)
  }, [token])

  const buildUrl = result => {
    let url = `${proxyPath}/checkpoint-mock/signing/doSign?resursToken=${encodeURIComponent(token)}&result=${result}`
    if (signerIndex) url += `&signerIndex=${encodeURIComponent(signerIndex)}`
    return url
  }

  return (
    <>
      <h1>Document Signing</h1>
      <p>Review the document below and sign to complete the process.</p>

      {session?.signers?.length > 0 && (
        <div className={styles.infoSection}>
          <div className={styles.sectionLabel}>Signers</div>
          {session.signers.map(s => (
            <div key={s.governmentId || s.name} className={styles.listItem}>
              <span>{s.name || 'Unknown'}</span>
              {s.governmentId && (
                <span className={styles.meta}>{s.governmentId}</span>
              )}
              <span className={styles.badge}>{s.status}</span>
            </div>
          ))}
        </div>
      )}

      {docs.length > 0 && (
        <div className={styles.infoSection}>
          <div className={styles.sectionLabel}>Documents</div>
          {docs.map(d => {
            const url = `${proxyPath}/checkpoint-romeo-signing/${token}/documents/${d.index}`
            return (
              <div key={d.index} className={styles.listItem}>
                <span>
                  {d.source ||
                    (d.contentType?.toLowerCase().includes('pdf')
                      ? 'PDF document'
                      : 'Document')}
                </span>
                {docOpensInViewer(d.contentType) ? (
                  <button
                    type="button"
                    className={styles.docLink}
                    onClick={() => openDoc({ doc: d, url })}
                  >
                    Open
                  </button>
                ) : (
                  <a href={url} download className={styles.docLink}>
                    Download
                  </a>
                )}
              </div>
            )
          })}
        </div>
      )}

      {session?.documentText && docs.length === 0 && (
        <div className={styles.documentText}>{session.documentText}</div>
      )}

      <div className={styles.lineWrapper}>
        <Button
          id="successButtonId"
          fullWidth
          onClick={() => {
            window.location.href = buildUrl('COMPLETE')
          }}
        >
          Sign Document
        </Button>
      </div>
      <div className={styles.lineWrapper}>
        <Button
          id="failureButtonId"
          type={ButtonType.Secondary}
          fullWidth
          onClick={() => {
            window.location.href = buildUrl('CANCEL')
          }}
        >
          Cancel
        </Button>
      </div>
      {isInternal && (
        <UseRealServiceButton
          apiPath={`${proxyPath}/checkpoint-romeo-signing/${token}/use_real_service`}
        />
      )}
      {previewDoc && (
        <DocViewerModal
          doc={previewDoc.doc}
          url={previewDoc.url}
          onClose={closeDoc}
        />
      )}
    </>
  )
}
